import BatchContainer from './container';

export default BatchContainer;